import {getNextId as _getNextId} from "../../util/misc";

export namespace nsToggle {
    export function getNextId(): string {
        return 'toggle_' + _getNextId();
    }
}
